module.exports = __webpack_public_path__ + "static/media/excel.b0ce6444.png";